import config from 'config';
import sfax from 'sfax';

sfax.baseUrl = '';

let { adDomain } = config;

export default {
    getAdData: payload => {
        if (adDomain != "//adv-sv-show.focus.cn") {
            // console.log('adDomain', adDomain);
            adDomain = '//adv-sv-show.focus-test.cn';
        }
        return sfax({
            url: adDomain + '/focus_say',
            jsonp: true,
            data: payload,
            contentType: 'application/x-javascript;charset=UTF-8'
        })
    },
    sendLogForAd: payload => {
        return sfax({
            url: '/baseApi/sendLogForAd',
            type: 'get',
            data: payload
        })
    },
    getAdDataByPage: payload => {
        return sfax({
            url: '/baseApi/yunying/getDataByPageIndex',
            type: 'get',
            data: payload
        })
    },
};



// WEBPACK FOOTER //
// ./src/model/api/ad.js